var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"promotion-corner",style:({ left: _vm.offset + 'px', top: _vm.offset + 'px' })},[_c('svgicon',{attrs:{"src":_vm.icon,"width":21,"height":21}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }